import { FormSectionHandler } from '../entity.handler';
import { EmailProviderResponse, EmailProviderUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, IdNameComboValueHandlers } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    type?: IdName;
}

export class EmailDetailsSectionHandler implements FormSectionHandler<EmailProviderResponse, EditorValues> {

    type = 'form';
    icon = ICONS.email;
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.EMAILPROVIDER.DETAILS.${key}`, values);
    }

    applyUpdate(entity: EmailProviderResponse, payload: EmailProviderUpdateRequest): Promise<EmailProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateEmailProvider(entity.id, payload));
    }

    mapEntityToEditor(entity: EmailProviderResponse): Promise<EditorValues> {
        const result = {
            name: entity.name,
            type: entity.type,
        };
        Object.keys(result).forEach(key => result[key] === undefined && delete result[key]); // strip undefined properties from the object
        return Promise.resolve(result);
    }

    mapEditorToEntity(entity: EmailProviderUpdateRequest, values: EditorValues): Promise<EmailProviderUpdateRequest> {

        const patch: EmailProviderUpdateRequest = {
            name: values.name,
            type: values.type,
        };
        Object.keys(patch).forEach(key => patch[key] === undefined && delete patch[key]); // strip undefined properties from the object

        return Promise.resolve(EntityUtils.mergeFields(['name', 'type'], patch, entity));

    }

    async getFields(entity: EmailProviderResponse): Promise<FormBuilderField[]> {
        const types = await this.admin.getCached(`listEmailProviderTypes/${this.ownerId}/0/100/name/null`, api => api.entities.listEmailProviderTypes(this.ownerId, 0, 100, 'name', null));
        const fields: FormBuilderField[] = [
            { ...ComboField('type', this.translate('FIELDS.TYPE'), true, EntityUtils.idNameToComboValues(types.items), IdNameComboValueHandlers), readonly: !this.creating },
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
        ];
        return EntityUtils.prepareBulk(!entity, [], fields);

    }

}
